import { GlSkeletonLoader } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
export default {
    name: 'SkeletonNote',
    components: {
        GlSkeletonLoader,
        TimelineEntryItem
    }
};
